import { useState } from 'react'

import { GretaAIChatSource } from '../../GretaAIChat.constants'
import {
  getGretaAIChatSelectedSource,
  getIsGretaAIChatNewChat,
} from '../../GretaAIChat.utils.source'

export function useGretaAIChatSource({ activeChat, activeChatId }) {
  const [newChatSource, setNewChatSource] = useState(GretaAIChatSource.Crm)
  const [sourceSwitchCount, setSourceSwitchCount] = useState(0)
  const [prevActiveChatId, setPrevActiveChatId] = useState(activeChatId)

  // A new chat opens in CRM once the user has been in a saved one.
  if (activeChatId !== prevActiveChatId) {
    setPrevActiveChatId(activeChatId)

    if (!getIsGretaAIChatNewChat(activeChatId)) {
      setNewChatSource(GretaAIChatSource.Crm)
    }
  }

  const source = getGretaAIChatSelectedSource({
    activeChat,
    activeChatId,
    newChatSource,
  })

  function selectSource(nextSource) {
    if (nextSource !== newChatSource) {
      setNewChatSource(nextSource)
      setSourceSwitchCount(count => count + 1)
    }
  }

  // The unsaved feed keeps the source its question was sent with.
  function pinSource(sentSource) {
    setNewChatSource(sentSource)
  }

  return { pinSource, selectSource, source, sourceSwitchCount }
}
